'use strict';

var React = require('react');
var index = require('./index-fccd5f88.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".Page_module_visuallyHidden__492cd44e {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.Page_module_youtubeVideo__492cd44e {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.Page_module_PageWrapper__492cd44e {\n  max-width: 1920px;\n  margin: 0 auto;\n}\n\n.Page_module_FloatingPage__492cd44e {\n  margin: 24px 24px 0 24px;\n  left: 0;\n  right: 0;\n  border-radius: 50px 50px 0 0;\n  box-shadow: 0 -8px 16px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n@media only screen and (max-width: 1580px) {\n  .Page_module_FloatingPage__492cd44e {\n    margin: 0;\n    border-radius: 0;\n    overflow: inherit;\n  }\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Pages/PageWrapper/Page.module.scss");
var modules_3ca4fc74 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"Page_module_visuallyHidden__492cd44e","youtubeVideo":"Page_module_youtubeVideo__492cd44e","PageWrapper":"Page_module_PageWrapper__492cd44e","FloatingPage":"Page_module_FloatingPage__492cd44e"};

function PageWrapper(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_3ca4fc74.PageWrapper,
    style: {
      backgroundColor: props.backgroundColor
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: props.floatingPage ? modules_3ca4fc74.FloatingPage : null
  }, props.children));
}
var pageWrapperPropTypes = {
  backgroundColor: index.propTypes.exports.string,
  floatingPage: index.propTypes.exports.bool
};
PageWrapper.propTypes = pageWrapperPropTypes;

exports.PageWrapper = PageWrapper;
